import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import {
  type PimProductV11,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { useOpenableControls } from '../../../../generic-hooks'
import {
  priceGetFormattedPercentageDiscount,
  priceGetFormattedPrice,
} from '../../../../price'
import { useProductPageContext } from '../../productPageContext'
import { ProductPrescriptionBonusDialog } from '../../ProductPrescriptionBonusDialog/ProductPrescriptionBonusDialog'
import { type ProductPrices, useProductPrices } from '../hooks/useProductPrices'

type ProductPageVariantBonusProps = {
  product: PimProductV11
}

export const ProductPageVariantBonus: FC<ProductPageVariantBonusProps> = ({
  product,
}) => {
  const intl = useIntl()

  const { currentPrescriptionType, currentVariant, offerId } =
    useProductPageContext()
  const { discount, displayPrice, isDiscountValid }: ProductPrices =
    useProductPrices({
      currentPrescriptionType,
      offerId,
      product,
    })
  const modalControls = useOpenableControls()

  if (
    currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.NoPrescription &&
    discount &&
    isDiscountValid
  ) {
    return (
      <div className="inline-flex min-w-12 items-center justify-center rounded-2xl bg-light-tertiary px-2 py-1 text-xs font-medium text-dark-primary-max">
        {priceGetFormattedPercentageDiscount(discount)}
      </div>
    )
  }

  if (
    currentPrescriptionType !== PrescriptionPrescriptionTypeEnum.NoPrescription
  ) {
    const badgeClassName =
      'inline-block min-w-12 rounded-2xl py-1 px-2 text-center font-bold text-dark-primary-max text-xs'

    if (product.upid === currentVariant.upid && displayPrice?.bonus) {
      return (
        <>
          <button
            className={clsx(badgeClassName, 'bg-light-tertiary')}
            data-qa-id="product-variant-mobile-prescription-badge"
            onClick={modalControls.handleOpen}
            type="button"
          >
            {priceGetFormattedPrice(displayPrice.bonus, intl)}
          </button>
          <ProductPrescriptionBonusDialog
            isOpen={modalControls.isOpen}
            onClose={modalControls.handleClose}
          />
        </>
      )
    }

    return (
      <span
        className={clsx(
          badgeClassName,
          displayPrice?.bonus ? 'bg-light-tertiary' : 'bg-light-primary-high',
        )}
      >
        {priceGetFormattedPrice(displayPrice?.bonus ?? 0, intl)}
      </span>
    )
  }

  return <div className="min-w-12" />
}
